// BREACH RESPONSIBLE AREA
export const GET_BREACH_RESPONSIBLE_AREAS = '/breach-responsible-area/query';
export const GET_BREACH_RESPONSIBLE_AREA = '/breach-responsible-area/';
export const POST_BREACH_RESPONSIBLE_AREA = '/breach-responsible-area/';
export const PUT_BREACH_RESPONSIBLE_AREA = '/breach-responsible-area/';
export const DELETE_BREACH_RESPONSIBLE_AREA = '/breach-responsible-area/';
